import { render, staticRenderFns } from "./timeTable.vue?vue&type=template&id=654d4c92"
import script from "./timeTable.vue?vue&type=script&lang=js"
export * from "./timeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports